import script from "./goRinSyo0077.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0077.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0077.vue?vue&type=style&index=0&id=6cab549c&lang=scss"

const __exports__ = script;

export default __exports__